import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'

export const PTO_HANDBOOK_STATUS_OBJECT_URL = `${PTO_URL}/object-status`

const errors = createBaseResponseErrors('статус объекта', 'статусов объекта')

export const PTOHandbookObjectStatusApi = createBaseCRUDApi(PTO_HANDBOOK_STATUS_OBJECT_URL, errors)
